/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Appointment from './Appointment/index'
import React from 'react'
import VirtualizedList from 'DesignSystem/VirtualizedList/index'
import useListItemDataOnSubmit from './useListItemDataOnSubmit.js'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Agenda/Appointments/Content"
  
}) {
let selectedTabValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'tab',
})
let appointmentBookingsValueData = fromData.useDataValue({ viewPath,
context: 'appointment_bookings',
})
let aggregateData = fromHelpers.filterByActiveTab(selectedTabValueData, appointmentBookingsValueData)
  return (<React.Fragment
>
<VirtualizedList
  viewPath={`${viewPath}/VirtualizedList`}
 data="selected.tab"
 data="appointment_bookings"
 aggregate="helpers.js filterByActiveTab"
 from={aggregateData}
 itemDataContextName="appointment_booking"
 sizeEstimate={70}
 childName="Appointment"
 paddingTop={4}
 paddingRight={4}
 paddingBottom={4}
 paddingLeft={4}
>
{childProps => (
<Appointment
{...childProps}
/>
)}
</VirtualizedList>
{children}
</React.Fragment>)
}